export const enum BannerView {
  WITH_LEAD_BUTTON = 'withLeadButton',
  WITHOUT_LEAD_BUTTON = 'withoutLeadButton',
}

export const enum METRIKA_GOALS {
  INSTALL_BANNER_WO_PROMO_CLICK = 'INSTALL_BANNER_WO_PROMO_CLICK',
  INSTALL_BANNER_WITH_PROMO_PROMO_CODE_CLICK = 'INSTALL_BANNER_WITH_PROMO_PROMO_CODE_CLICK',
  INSTALL_BANNER_WITH_PROMO_INSTALL_CLICK = 'INSTALL_BANNER_WITH_PROMO_INSTALL_CLICK',
  COPIED_COUPON_BANNER_GO_TO_APP_CLICK = 'COPIED_COUPON_BANNER_GO_TO_APP_CLICK',
}
